exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "th.pass-td {\n    padding-left: 2px;\n    padding-right: 2px;\n    text-align: center;\n}\n\ntd.pass-td {\n    overflow: visible;\n    background: rgba(200,200,200,0.1);\n    vertical-align: middle;\n    text-align: center;\n    position: relative;\n}\ntd.pass-td.top {\n    vertical-align: top;\n}\n\ndiv.pass-block {\n    position: absolute;\n    top: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: -10px;\n    padding: 10px;\n    background: rgba(200,200,200,0.3);\n}\n\ndiv.pass-block input.passinp {\n    width: 12em;\n}\n\ntd.pass-td > span {\n    padding: 1em;\n}\n\ntd.pass-td > span:hover {\n    color: black;\n}\n\ntd span.itshid {\n    visibility: hidden;\n}\n\ntr.inactive-val td span.val-act {\n    background-color: rgba(0,0,0,0.12);\n    color: white;\n}\n\ntd span.val-act {\n    background-color: transparent;\n    color: rgba(0,255,0,0.95);\n}\n\ntd.remove-td {\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/users/users-list.css
// module id = 1231
// module chunks = 9